import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { HospitalItem, Hospital } from '../models';

export class HospitalApi extends ApiModule {
  protected endpoint = '/hospital';

  public async pageHospitals(params: any) {
    return this.api.post<PaginatedResponseData<HospitalItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadHospitalDetails(id: number) {
    return this.api.get<Hospital>(`${this.endpoint}?id=${id}`);
  }

  public saveHospital(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deleteHospital(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }
}
